import React, { Fragment, useState } from 'react';
import List from "@mui/material/List";
import ListItem from "@mui/material/List";
import Collapse from "@mui/material/Collapse";
import { NavLink, useNavigate } from "react-router-dom";
import { useSelector, useDispatch } from 'react-redux';
import { logout } from '../../store/actions/authActions';
import logoBianco from '../../images/logo/finale-gattomio-black.jpg.jpeg';
import './style.css';

const menus = [
    { id: 1, title: 'Home', link: '/' },
    {
        id: 2,
        title: 'Il Mondo Kleeo',
        link: '#',
        submenu: [
            { id: 21, title: 'Kleeo', link: '/kleeo/la-rivoluzione-pulita' },
            { id: 22, title: 'Come Funziona', link: '/come-funziona' },
            { id: 23, title: 'Offerta Lancio', link: '#offerta-lancio' },
            { id: 24, title: 'Garanzia e Sicurezza', link: '#garanzia-sicurezza' },
        ]
    },
    { id: 3, title: 'Faq', link: '/faq' },
    { id: 4, title: 'Shop', link: '/shop' },
    { id: 5, title: 'News', link: '/blog' },
    { id: 6, title: 'Contatti', link: '/contact' },
]


const MobileMenu = () => {

    const [openId, setOpenId] = useState(0);
    const [menuActive, setMenuState] = useState(false);
    const [userDropdownOpen, setUserDropdownOpen] = useState(false);
    const dispatch = useDispatch();
    const navigate = useNavigate();

    const { isAuthenticated, user } = useSelector(state => state.auth);

    const ClickHandler = () => {
        window.scrollTo(10, 0);
    }

    const handleLogout = async () => {
        setUserDropdownOpen(false);
        setMenuState(false);
        await dispatch(logout());
        navigate('/');
    }

    const handleLoginClick = () => {
        setMenuState(false);
    }

    const handleAnchorClick = (anchor) => {
        setMenuState(false);
        setTimeout(() => {
            if (window.location.pathname === '/') {
                const el = document.querySelector(anchor);
                if (el) {
                    const offset = 80;
                    const top = el.getBoundingClientRect().top + window.pageYOffset - offset;
                    window.scrollTo({ top, behavior: 'smooth' });
                }
            } else {
                navigate('/', { state: { scrollTo: anchor.replace('#', '') } });
            }
        }, 300);
    };

    return (
        <div>
            <div className={`mobileMenu ${menuActive ? "show" : ""}`}>
                <div className="mobile-menu-header">
                    <div className="mobile-menu-logo">
                        <img src={logoBianco} alt="logo" />
                    </div>
                    <div className="menu-close">
                        <div className="clox" onClick={() => setMenuState(!menuActive)}><i className="ti-close"></i></div>
                    </div>
                </div>

                <ul className="responsivemenu">
                    {menus.map((item, mn) => {
                        return (
                            <ListItem className={item.id === openId ? 'active' : null} key={mn}>
                                {item.submenu ?
                                    <Fragment>
                                        <p onClick={() => setOpenId(item.id === openId ? 0 : item.id)}>{item.title}
                                            <i className={item.id === openId ? 'fa fa-angle-up' : 'fa fa-angle-down'}></i>
                                        </p>
                                        <Collapse in={item.id === openId} timeout="auto" unmountOnExit>
                                            <List className="subMenu">
                                                <Fragment>
                                                    {item.submenu.map((submenu, i) => {
                                                        return (
                                                            <ListItem key={i}>
                                                                {submenu.link.startsWith('#') ? (
                                                                    <a className="active" href={submenu.link}
                                                                        onClick={(e) => { e.preventDefault(); handleAnchorClick(submenu.link); }}>
                                                                        {submenu.title}
                                                                    </a>
                                                                ) : (
                                                                    <NavLink onClick={ClickHandler} className="active"
                                                                        to={submenu.link}>{submenu.title}</NavLink>
                                                                )}
                                                            </ListItem>
                                                        )
                                                    })}
                                                </Fragment>
                                            </List>
                                        </Collapse>
                                    </Fragment>
                                    : <NavLink className="active"
                                        to={item.link}>{item.title}</NavLink>
                                }
                            </ListItem>
                        )
                    })}
                </ul>

                {/* Auth area mobile */}
                <div className="mobile-auth-section">
                    {isAuthenticated ? (
                        <div>
                            <button
                                className="mobile-user-btn"
                                onClick={() => setUserDropdownOpen(!userDropdownOpen)}
                            >
                                <i className="ti-user"></i>
                                <span>{user?.name?.split(' ')[0] || 'Account'}</span>
                                <i className={`ti-angle-${userDropdownOpen ? 'up' : 'down'}`}></i>
                            </button>
                            {userDropdownOpen && (
                                <ul className="mobile-user-submenu">
                                    <li>
                                        <NavLink
                                            to="/account"
                                            onClick={() => {
                                                setUserDropdownOpen(false);
                                                ClickHandler();
                                            }}
                                        >
                                            Il mio account
                                        </NavLink>
                                    </li>
                                    <li>
                                        <NavLink
                                            to="/orders"
                                            onClick={() => {
                                                setUserDropdownOpen(false);
                                                ClickHandler();
                                            }}
                                        >
                                            I miei ordini
                                        </NavLink>
                                    </li>
                                    <li>
                                        <button onClick={handleLogout} className="logout-btn">
                                            Esci
                                        </button>
                                    </li>
                                </ul>
                            )}
                        </div>
                    ) : (
                        <NavLink
                            to="/login"
                            onClick={handleLoginClick}
                            className="mobile-login-btn"
                        >
                            <i className="ti-user"></i> Accedi
                        </NavLink>
                    )}
                </div>

            </div>

            <div className="showmenu mobail-menu" onClick={() => setMenuState(!menuActive)}>
                <button type="button" className="navbar-toggler open-btn">
                    <span className="icon-bar first-angle"></span>
                    <span className="icon-bar middle-angle"></span>
                    <span className="icon-bar last-angle"></span>
                </button>
            </div>
        </div>
    )
}

export default MobileMenu;